import { useState } from 'react';

const HeaderState = () => {
  const [activeTab, setActiveTab] = useState('signin');
  const [menuOpen, setMenuOpen] = useState(false);
  const [showTabs, setShowTabs] = useState(false);
  const [selectedTier, setSelectedTier] = useState(null);
  const [formData, setFormData] = useState({ email: '', password: '', rememberMe: false });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.email) newErrors.email = 'Email is required';
    else if (!validateEmail(formData.email)) newErrors.email = 'Please enter a valid email';

    if (!formData.password) newErrors.password = 'Password is required';
    else if (formData.password.length < 6) newErrors.password = 'Password must be at least 6 characters';

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setIsLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setIsLoading(false);
      alert('Sign in successful!');
    }
  };

  return {
    activeTab, setActiveTab, menuOpen, setMenuOpen, showTabs, setShowTabs, selectedTier, setSelectedTier, 
    formData, setFormData, errors, setErrors, isLoading, setIsLoading, handleSubmit
  };
};

export default HeaderState;
